export default __webpack_public_path__ + "locales/ro/SocialAuthWelcomeDialog.json?hash=13e55074e79bfcb982945c1027e4ba04";